import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getRemoteConfig } from 'firebase/remote-config';

import { FirebaseContext } from '../context/FirebaseContext';

export const FirebaseProvider = ({ children }) => {
  const firebaseConfig = {
    apiKey: 'AIzaSyC0akBDjilw8niYjWcV01Zn0abQL-xN9gE',
    authDomain: 'fintask-62a00.firebaseapp.com',
    projectId: 'fintask-62a00',
    storageBucket: 'fintask-62a00.firebasestorage.app',
    messagingSenderId: '861287009973',
    appId: '1:861287009973:web:7e93d557d63386511938fc',
    measurementId: 'G-XNE6LTNMX0'
  };

  const firebase = initializeApp(firebaseConfig);
  const auth = getAuth(firebase);
  const remoteConfig = getRemoteConfig(firebase);

  return (
    <FirebaseContext.Provider value={{ auth, remoteConfig }}>{children}</FirebaseContext.Provider>
  );
};
